import { useMutation, useQueryClient } from "react-query";
import { Post } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";
import { Organization } from "../../types/api/User";

export interface JoinOrganizationBody {
  selected_type: string;
  name: string;
}

export default () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  return useMutation<Organization, null, JoinOrganizationBody>(
    async (body: JoinOrganizationBody) =>
      Post(`/api/organization`, await getAccessTokenSilently(), body),
    {
      onSuccess: () => {
        // after joining an organization, we the response sent via auth0
        queryClient.invalidateQueries([`user`]);
        localStorage.removeItem("buyer_invite_id");
        localStorage.removeItem("buyer_org_id");
      },
    }
  );
};
